export const LEGAL_ENTITY_ID = '6242fac5909b4c8045385e77';
